import React from 'react'
import { ProjectName } from '../assets'
import Layout from '../layouts'
import Title from '../components/CustomTitle'
import withAccessGranted from '../components/WithAccessGranted'
import userAccess from '../userAccess'

const Home = () => (
    <Layout>
        <Title>{ProjectName}</Title>
    </Layout>
)

export default withAccessGranted(Home, [
    userAccess.ADMIN.ACCESS_LEVEL,
    userAccess.COMMERCE.ACCESS_LEVEL,
    userAccess.ESTABLISHMENT.ACCESS_LEVEL,
    userAccess.SELLER.ACCESS_LEVEL
])
